import { rankingItems } from "@/mocks/home";

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热播榜单</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">全网热度排名 — 大家都在看</p>
        </div>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.id}
              href="#media"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? "border-b border-background-200/50" : ""
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                item.rank === 1
                  ? "bg-accent-500 text-white"
                  : item.rank === 2
                  ? "bg-primary-500/20 text-primary-600"
                  : item.rank === 3
                  ? "bg-secondary-500/20 text-secondary-600"
                  : "bg-background-200 text-foreground-500"
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-500">{item.views}次播放</span>
                  <span className="text-[11px] font-medium text-accent-500">{item.trend}</span>
                </div>
              </div>
              <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-secondary-100 text-secondary-700">
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}